var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5966"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.717 5.21525C10.5675 5.12599 10.6021 4.90342 10.7594 4.84743L12.462 4.21301C12.5297 4.19122 12.5834 4.13239 12.595 4.0582L13.0304 2.27729C13.0726 2.10106 13.2874 2.05729 13.3895 2.1961L14.456 3.61499C14.4968 3.67051 14.5658 3.70434 14.6361 3.69799L16.428 3.50833C16.5992 3.48939 16.7027 3.68381 16.6067 3.82309L15.5644 5.33661C15.526 5.39232 15.5145 5.46651 15.5426 5.5406L16.214 7.20763C16.2791 7.36198 16.1333 7.53537 15.9672 7.48941L14.2549 7.00834C14.1884 6.98996 14.1117 7.00559 14.0644 7.05515L12.6938 8.26043C12.5621 8.37508 12.3577 8.28904 12.3603 8.1129L12.3459 6.29598C12.3421 6.22492 12.3076 6.16011 12.254 6.12316L10.717 5.21525Z",
    fill: "#FFC71B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.3026 6.47973C14.0854 6.41227 13.8489 6.46845 13.6763 6.62336L12.7136 7.46614L12.7027 6.19925C12.7041 5.96749 12.5828 5.76075 12.3886 5.64069L11.3333 5.00974L12.5208 4.56813C12.6563 4.52455 12.7752 4.42848 12.8583 4.30777C12.9095 4.23348 12.9453 4.16233 12.9632 4.07885L13.2655 2.83594L14.0075 3.82608C14.148 4.00497 14.3613 4.09716 14.5876 4.075L15.835 3.94843L15.106 5.00696C14.9717 5.20195 14.9396 5.43996 15.0302 5.65296L15.4987 6.81062L14.3026 6.47973Z",
    fill: "url(#paint0_linear_10384_64554)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.5855 11.7945C11.4906 11.5969 11.6817 11.3873 11.8857 11.4378L12.7828 11.6513C12.8691 11.6755 12.9664 11.6511 13.0301 11.5812L13.7108 10.9533C13.8776 10.7977 14.1335 10.901 14.1443 11.1177L14.2027 12.0228C14.207 12.1095 14.256 12.193 14.3342 12.2352L15.1478 12.6593C15.3407 12.7584 15.3142 13.0345 15.1166 13.114L14.2475 13.4641C14.1685 13.4959 14.1048 13.5657 14.0828 13.6631L13.9079 14.5589C13.869 14.7662 13.5954 14.8469 13.4529 14.6832L12.8678 13.9903C12.8108 13.9248 12.7194 13.8879 12.6353 13.907L11.7057 14.0308C11.4877 14.0597 11.3329 13.8272 11.4581 13.6441L11.9568 12.8684C12.0022 12.7912 12.0111 12.6991 11.9804 12.623L11.5855 11.7945Z",
    fill: "#FFC71B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.3677 13.8626C13.1113 13.5679 12.7326 13.4257 12.3281 13.4854L12.026 13.5333L12.1967 13.273C12.4127 12.9354 12.446 12.524 12.2766 12.1795L12.1511 11.9058L12.4545 11.9752C12.69 12.0278 12.9445 12.0137 13.1683 11.9236C13.3 11.8705 13.4347 11.7868 13.5327 11.6884L13.7552 11.4808L13.7703 11.7843C13.7897 12.1745 14.0169 12.5104 14.3663 12.694L14.6375 12.8353L14.3478 12.952C13.9791 13.1005 13.7082 13.416 13.6333 13.7999L13.5672 14.0919L13.3677 13.8626Z",
    fill: "url(#paint1_linear_10384_64554)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.26269 6.29105C4.27019 6.08167 4.51528 5.96822 4.68703 6.09067L6.79482 7.60018C6.85987 7.64768 6.94104 7.65921 7.02515 7.64007L9.5796 6.8766C9.78224 6.80973 9.96636 7.00089 9.89597 7.20612L9.01986 9.66681C8.98762 9.73875 9.0051 9.82015 9.04891 9.89095L10.5236 11.9945C10.6397 12.1688 10.5166 12.3952 10.3016 12.3934L7.64255 12.403C7.56649 12.4042 7.47431 12.4413 7.42379 12.5059L5.78086 14.5826C5.65054 14.753 5.38876 14.7111 5.32531 14.5155L4.56764 12.0643C4.537 11.9882 4.48001 11.9227 4.41201 11.9058L1.92187 11.081C1.72593 11.0125 1.68666 10.763 1.86376 10.6327L4.04884 9.1041C4.12274 9.05959 4.15499 8.98765 4.16384 8.89564L4.26269 6.29105Z",
    fill: "#FFC71B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.03674 11.5955C4.96603 11.3439 4.76363 11.1454 4.51797 11.0674L2.62879 10.4427L4.29065 9.28698C4.50725 9.14079 4.65154 8.89105 4.66495 8.62033L4.74641 6.65657L6.34405 7.81142C6.55746 7.96131 6.83751 8.01066 7.09793 7.93526L9.03426 7.34702L8.36125 9.21001C8.27474 9.45121 8.31106 9.73138 8.46078 9.95114L9.57902 11.5496L7.55984 11.5522C7.45233 11.5512 7.33677 11.5683 7.23142 11.6107C7.08657 11.6691 6.95704 11.7655 6.86406 11.8766L5.61722 13.4548L5.03674 11.5955Z",
    fill: "url(#paint2_linear_10384_64554)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10384_64554",
    x1: 18.0105,
    y1: 12.5331,
    x2: 15.0814,
    y2: 7.56231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4302,
    stopColor: "#E3B117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6573,
    stopColor: "#F1CF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8616,
    stopColor: "#FBE338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10384_64554",
    x1: 13.2016,
    y1: 14.5475,
    x2: 13.5453,
    y2: 7.98818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0167598,
    stopColor: "#E3B117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    stopColor: "#F1CF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#FBE338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    stopColor: "#FEEA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10384_64554",
    x1: 5.67551,
    y1: 16.101,
    x2: 6.07688,
    y2: 8.44054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3B117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3986,
    stopColor: "#F1CF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7571,
    stopColor: "#FBE338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEA3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.27dfbb24fe31ed91b029fc28a21cfafb.svg";
export { ForwardRef as ReactComponent };